import { createRegisterableComposition } from '@news-mono/web-common'
import React from 'react'
import { ResponsiveContainer } from '../../content/Picture/responsive'
import { ContentWrapper } from '../ContentWrapper/ContentWrapper'
import { BaseCompositionProps } from '../types'
import { Kratos } from './Kratos'

export interface KratosRouteProps extends BaseCompositionProps {}

// So named becuase it was made for the Developing/Breaking News Initiative
export const KratosRegistration = createRegisterableComposition<'main'>()(
    'kratos',
    (contentAreas, props: KratosRouteProps) => (
        <ContentWrapper>
            <Kratos {...props} mainContent={contentAreas.main} />
        </ContentWrapper>
    ),
    (
        _contentArea,
        {
            containerWidthRatios = { desktop: 1, tablet: 1, mobile: 1 },
        }: KratosRouteProps & ResponsiveContainer,
    ): ResponsiveContainer => {
        return {
            containerWidthRatios: {
                desktop: containerWidthRatios.desktop,
                tablet: containerWidthRatios.tablet,
                mobile: containerWidthRatios.mobile,
            },
        }
    },
)
